<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import type { Purchase } from '../../../modules/paymentsApi/purchases/purchase.entity'
    import { GridBadge, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import { faBarcode, faSearchDollar, faFileInvoiceDollar, faQrcode } from '@fortawesome/free-solid-svg-icons'
    import PaymentsPixShow from '../../payments/payments-pix-show.svelte'
    import type { Charge } from '../../../modules/paymentsApi/charges/charge.entity'
    import { ChargeStatus, ChargeStatusFriendly } from '../../../modules/paymentsApi/charges/charge.enum'
    import Content from '../../_common/content.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Popover from '../../_common/popover.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    let dispatch = createEventDispatcher()

    let purchase: Purchase
    export let onlyOverdue = false
    export let allowBankslip = false

    onMount(async () => {
        await loadEntity()
    })

    async function loadEntity() {
        if (!window.store.company.planPurchaseId) return
        purchase = await window.api.payments.purchases.getOnePublic(window.store.company.planPurchaseId, true)
        console.log('public_purchase', purchase)
        if (purchase) {
            loadGrid()
        }
    }

    let bankslipUrl = null
    let show = false
    async function goBoleto(chargeId: string) {
        if (!confirm('Deseja mesmo gerar um boleto avulso para esta parcela?\nAtenção: caso já haja um boleto a vencer o novo boleto não será gerado.')) {
            return
        }
        try {
            show = true
            const result = await window.api.payments.charges.singleCharge(chargeId)
            await loadEntity()
            window.alert('Boleto gerado.\nClique no botão para visualizar ou copiar o código de barras.')
            console.log('goBoleto', result)
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function goNewCard() {
        let url = window.api.utils.utils.domain() + '/public/checkout-card?id=' + purchase.purchaseId
        window.open(url, '_blank')
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = onlyOverdue ? 'Valores em aberto' : 'Últimas mensalidades'
        grid.subtitle = 'ID da assinatura: ' + (purchase.purchaseId || '-')
        grid.showActs = false
        grid.subtitle = ''
        if (purchase.purchaseMethod === 'credit')
            grid.acts = [
                new GridButton({
                    callback: () => goNewCard(),
                    icon: faFileInvoiceDollar,
                    color: 'primary',
                    label: 'Alterar Cartão',
                }),
            ]
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Vencimento', type: GridColTypeEnum.date }))
        if (purchase.purchaseMethod !== 'bankslip') {
            grid.cols.push(new GridCol({ content: 'Última tentativa', type: GridColTypeEnum.date }))
            grid.cols.push(new GridCol({ content: 'Próxima tentativa', type: GridColTypeEnum.date }))
        }
        grid.cols.push(new GridCol({ content: 'Pago em', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        purchase.charges.reverse()
        let count = 0
        let overdue = false
        let emitOverdue = false
        let isPaid = false
        for (const item of purchase.charges) {
            //item.dueDate = new Date(item.dueDate)
            //item.dueDate.setMinutes(item.dueDate.getMinutes() - item.dueDate.getTimezoneOffset())
            isPaid = item.status >= 200 || item.status == 70 || item.status == 75
            const dueDate = new Date(item.dueDate)
            let btnBankslip = null

            if (!isPaid && dueDate.getTime() < new Date().getTime() - 1000 * 60 * 60 * 20) {
                emitOverdue = true
                overdue = true
                const dueDateInDays = (new Date().getTime() - dueDate.getTime()) / 1000 / 60 / 60 / 24
                if (item.paymentMethod === 'credit' && dueDateInDays > 3) {
                    btnBankslip = new GridButton({
                        callback: () => goBoleto(item.chargeId),
                        icon: faFileInvoiceDollar,
                        label: 'Gerar boleto',
                    })
                }
            } else {
                overdue = false
                if (onlyOverdue) continue
            }

            let btns = []
            if (btnBankslip) btns.push(btnBankslip)

            if (!item.paidAt && !isPaid) {
                item.invoices.reverse()
                for (const inst of item.invoices) {
                    if (inst.paymentMethod == 'bankslip') {
                        if (!inst.bankslipUrl) continue
                        //
                        const btnBar = new GridButton({
                            callback: () => showBar(inst.bankslipLine),
                            icon: faBarcode,
                            label: 'Barras',
                        })
                        //
                        btns.push(btnBar)
                        const btnBankslip = new GridButton({
                            callback: () => showBankslip(inst.bankslipUrl),
                            icon: faFileInvoiceDollar,
                            label: 'Boleto',
                        })
                        btns.push(btnBankslip)
                        break
                    }
                    // aqui a condição era 'bankslip' de novo, então este bloco nunca rodava
                    if (inst.paymentMethod == 'pix') {
                        // sem o copia e cola não há o que exibir: o QR ainda não voltou do gateway
                        if (!inst.pixEMV) continue
                        // QR expirado não pode mais ser pago — não adianta oferecer
                        if (inst.dueDate && new Date(inst.dueDate).getTime() < new Date().getTime()) continue
                        const btnPix = new GridButton({
                            callback: () => showPix(item.chargeId),
                            icon: faQrcode,
                            label: 'Pagar com pix',
                        })
                        btns.push(btnPix)
                        break
                    }
                }
            }
            // const btnEdit = new GridButton({
            //     callback: () => showChargeDetail(item.chargeId),
            //     icon: faSearchDollar,
            //     label: 'Ver',
            // })
            // btns.push(btnEdit)
            let line: GridLine = new GridLine()
            line.slots.push({
                content: new GridBadge({ label: getBadgeLabel(item), class: getBadgeColor(item) }),
            })
            line.slots.push({ content: item?.dueDate })
            if (purchase.purchaseMethod !== 'bankslip') {
                line.slots.push({ content: item?.tryLast })
                line.slots.push({ content: item?.tryNext })
            }
            line.slots.push({ content: item?.paidAt })
            line.slots.push({ content: btns })
            grid.lines.push(line)
            count++
            if (count === 3) break
        }
        grid.lines.reverse()
        if (emitOverdue) dispatch('overdue')
    }

    function getBadgeLabel(charge: Charge) {
        let label = ChargeStatusFriendly[charge.statusLabel]
        if (label === 'agendado' && charge.tryNext) label = 'atrasado'
        return label
    }

    function getBadgeColor(charge: Charge) {
        if (charge.status === ChargeStatus.scheduled && charge.tryTimes > 0) {
            return 'status_overdue'
        }
        if (charge.status === ChargeStatus.paid) return 'status_100'
        if (charge.status === ChargeStatus.paid_manual) return 'status_100'
        if (charge.status === ChargeStatus.pending) return 'status_pending'
        // documento vencido: a mensalidade continua em aberto, então é aviso, não encerramento
        if (charge.status === ChargeStatus.expired) return 'status_pending'
        return 'status_default'
    }

    let charge = null
    function showChargeDetail(id: string) {
        charge = purchase.charges.find((el) => el.chargeId === id)
    }

    let lineBar = null
    function showBar(line: string) {
        lineBar = line
    }

    // quem está nesta tela é o próprio assinante indo pagar, então a tela do pix fica
    // acompanhando a confirmação (watchPayment) e recarrega a lista quando o pagamento entra
    let pixChargeId: string = null
    function showPix(chargeId: string) {
        pixChargeId = chargeId
    }

    async function closePix() {
        pixChargeId = null
        await loadEntity()
    }

    function showBankslip(url: string) {
        window.open(url, '_blank')
    }

    function closeChargeId() {
        charge = null
    }
</script>

<LoadSpinner delay={0} {show} />
{#if lineBar}
    <Popover title="Código e barras" width="680px" height="120px" on:close={() => (lineBar = null)}>
        <Zframe title="Código de Barras" class="m-3">
            <Zinput value={lineBar} disabled={true} showCopy={true}></Zinput>
        </Zframe>
    </Popover>
{/if}

{#if pixChargeId}
    <Popover title="Pagar com pix" width="560px" height="420px" on:close={closePix}>
        <PaymentsPixShow chargeId={pixChargeId} watchPayment={true} on:close={closePix} />
    </Popover>
{/if}

{#if grid.lines.length > 0}
    <Zgrid class="mt-3" {grid} />
{/if}
